import { useTranslation } from "react-i18next";

/**
 * HomePage — `/:lang` の LP 風 placeholder。
 *
 * 本番では顧客がここに来ることはなく、運営者が発行するマジックリンク URL
 * (/:lang/u/... or /:lang/r/...) から直接入る想定。ローカル開発時の動作確認用にとどめる。
 * 言語選択の導線は本画面ではなく、回答者が実際に入ってくる RespondentHome
 * (features/respond/components/RespondentHome.tsx) に前面化して置いている。
 */
export function HomePage() {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-[calc(100dvh-73px)] max-w-2xl flex-col items-center justify-center px-6 py-10 text-center">
      <h1 className="text-2xl font-semibold">{t("appName")}</h1>
      <p className="mt-3 text-lg text-muted-foreground">{t("home.tagline")}</p>
      <p className="mt-8 text-sm text-muted-foreground">{t("home.description")}</p>
    </main>
  );
}
